export const APP_SETSTATE = "APP_SETSTATE";